import { OrganizationType } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

export const useIsNonDentalOrganization = (): boolean => {
  const organization = useAppSelector(
    organizationModel.selectors.selectCurrentOrganization,
  );

  return organization?.Type === OrganizationType.OrganizationType_NonDental;
};
